<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 122.88 102.5"
  ><title>Increase Font Size</title><path d="M60.26,74.67H25.74L21.63,84.2a21,21,0,0,0-2,7.85,6.5,6.5,0,0,0,3.32,6c1.29.79,4.48,1.35,9.58,1.75v2.65H0V99.85a14.55,14.55,0,0,0,8.64-4.38c2.26-2.36,5.07-7.29,8.36-14.74l35-78h1.38L88.58,82.89c3.38,7.61,6.13,12.38,8.3,14.35a11.4,11.4,0,0,0,6.94,2.61v2.65H56.52V99.85h1.95c3.79,0,6.47-.54,8-1.6a3.85,3.85,0,0,0,1.6-3.32,8.42,8.42,0,0,0-.44-2.66c-.1-.45-.81-2.24-2.16-5.42l-5.2-12.18Zm54.22-42.83,8.4-9.21L99.2,0,75.9,22.27l8.41,9.21,8.57-8.29L93,49l12.91-.11-.13-25.46,8.68,8.38ZM57.8,69.33,43.26,35.67l-15,33.66Z" /></svg>
</template>
